import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { USER_ROLES } from '../constants';
import ClientProspectsPage from './ClientProspectsPage';
import LeadAgentProspectsPage from './LeadAgentProspectsPage';

const ProspectsPage = () => {
  const { user } = useContext(UserContext);
  if (user?.role === USER_ROLES.CLIENT) return <ClientProspectsPage />;
  return <LeadAgentProspectsPage />;
};

export default ProspectsPage;
